export default defineNuxtRouteMiddleware((from) => {
  const returnTo = useCookie('returnTo')
  // Need to check for and redirect with isRedirect query param to prevent infinite loop because cookie is not deleted fast enough
  if (returnTo.value && !from.query.isRedirect) {
    const redirectTo = returnTo.value
    returnTo.value = null
    return navigateTo({ name: redirectTo, query: { isRedirect: 'true' } })
  }
})
